const addParamToUrl = (url, key, value) => {
    url += value ? (url.split('?')[1] ? '&' : '?') + `${key}=${value}` : '';
    return url;
};

export default addParamToUrl;